<template>
  <div class="container">
    <p class="p-title text-center">我们的客户</p>
    <br />
    <br />
    <br />
    <b-row align-h="center">
      <b-col>
        <div>
          <swiper :options="swiperOption" class="text-center div-swiper">
            <swiper-slide v-for="(slide, index) of swiperArray" :key="index">
              <div class="block-div">
                <img
                  class="img"
                  :src="
                    require('../../../assets/images/companys/' + slide.img + '')
                  "
                />
                <p class="p-line">{{ slide.title }}</p>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "CompanyClient",
  data() {
    return {
      swiperArray: [
        {
          img: "garrett.png",
          title: "盖瑞特动力科技有限公司"
        },
        {
          img: "mahle.png",
          title: "马勒滤清系统有限公司"
        },
        {
          img: "pangood.png",
          title: "盘毂动力科技有限公司"
        },
        {
          img: "plastic.png",
          title: "彼欧英瑞杰汽车系统有限公司"
        },
        {
          img: "tpicomposites.png",
          title: "迪皮埃风电叶片有限公司"
        },
        {
          img: "ofu.jpg",
          title: "欧伏电气股份有限公司"
        },
        { img: "cc.jpg", title: "长城曼德电子电器有限公司" },
        { img: "faurecia.png", title: "东风佛吉亚汽车内饰有限公司" },
        { img: "hbrdt.png", title: "雷迪特冷却系统股份有限公司" },
        { img: "tenneco.png", title: "天纳克富晟汽车零部件有限公司" }
      ],
      swiperOption: {
        slidesPerView: 4,
        slidesPerColumn: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  }
};
</script>

<style lang="stylus" scoped>
.p-title {
  font-size: 1.9rem;
  margin-top: 5rem;
}

.div-swiper {
  margin-bottom: 4rem;

  .swiper-pagination {
    margin-bottom: -1rem;
  }
}

.block-div {
  width: 14.1rem;
  height: 10.4rem;
  margin-bottom: 2rem;
  margin-left: 0.5rem;
  box-shadow: 0rem 0.3rem 0.8rem 0rem rgba(2, 0, 0, 0.11);

  .img {
    width: 90%;
    margin-top: 10%;
  }

  .p-line {
    position: absolute;
    bottom: 30px;
    width: inherit;
    margin-top: 0.5rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/company/components/ContentClient.vue